<style scoped>
.users-title {
  float: left;
  font-weight: bold;
  font-size: 30px;
}
</style>

<template>
  <div class="content">
    <div class="users-title">Postcode toevoegen</div>
    <form @submit.prevent="toevoegen()">
      <br />
      <br />
      <div class="title is-5">Geauthoriseerde postcodes</div>

      <div class="columns">
        <div class="column is-6">
          <formInput
            class="customInput"
            :model="form"
            title="begin"
            modelKey="postcode_begin"
            label="on-border"
            placeholder="1234AB"
          />
        </div>
        <div class="column">
          <formInput
            class="customInput"
            :model="form"
            title="eind"
            modelKey="postcode_eind"
            label="on-border"
            placeholder="9999YZ"
          />
        </div>
      </div>

      <b-field>
        <b-switch v-model="all_house_numbers"
          >Alle huisnummers in postcode range</b-switch
        >
      </b-field>

      <span v-if="!all_house_numbers">
        <div class="title is-5">Geauthoriseerde huisnummers</div>

        <div class="columns">
          <div class="column is-6">
            <formInput
              class="customInput"
              :model="form"
              title="begin"
              modelKey="huisnummer_begin"
              label="on-border"
              placeholder="1"
            />
          </div>
          <div class="column">
            <formInput
              class="customInput"
              :model="form"
              title="eind"
              modelKey="huisnummer_eind"
              label="on-border"
              placeholder="200"
            />
          </div>
        </div>
        <br />
      </span>

      <formInput
        class="customInput"
        :model="form"
        modelKey="omschrijving"
        label="on-border"
      />

      <b-field>
        <b-switch v-model="form.status">Actief</b-switch>
      </b-field>

      <b-button
        native-type="submit"
        :loading="ajaxloading.create_postal_code_range"
        type="is-primary is-rounded"
        >Toevoegen</b-button
      >&nbsp;

      <b-button type="is-rounded" @click="$router.go(-1)">Annuleren</b-button>
    </form>
  </div>
</template>

<script>
export default {
  components: {},
  props: [],
  data() {
    return {
      all_house_numbers: true,
      form: {
        id: 0,
        status: true,
      },
    };
  },
  computed: {},
  methods: {
    toevoegen() {
      if (this.all_house_numbers) {
        this.form.huisnummer_begin = null;
        this.form.huisnummer_eind = null;
      }
      this.$store.dispatch("postalCodes/create", this.form).then(() => {
        this.$buefy.toast.open("Postcode aangemaakt");
        this.$router.push({ name: "postcode-index" });
      });
    },
  },
  mounted() {},
};
</script>
